// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tablet-container tablet-container--express-checkin-onsite-details-app\">\n  <main class=\"portal-main portal-main--onsite-details\" id=\"main-content\">\n    <section inject=\"content-view\">\n  </main>\n</div>\n";
},"useData":true});
